<div class="partner-details-view-container" *ngIf="partnerObject" fxLayout="column" fxLayoutGap="15px">

  <!--  <div class="status-gus-info" *ngIf="partnerObject.gusStatus">-->
  <!--    <mat-form-field appearance="fill" [ngClass]="'input-color-' + partnerObject.gusStatus.color">-->
  <!--      <mat-label>Gus Status</mat-label>-->
  <!--      <input matInput placeholder="GusStatus" [disabled]="true" [value]="partnerObject.gusStatus?.name">-->
  <!--    </mat-form-field>-->
  <!--  </div>-->

  <!--  <div class="excel-id-info" *ngIf="partnerObject">-->
  <!--    <mat-form-field appearance="fill" color="accent">-->
  <!--      <mat-label>Excel ID</mat-label>-->
  <!--      <input matInput placeholder="Excel ID" [disabled]="true" [value]="partnerObject.excelId">-->
  <!--    </mat-form-field>-->
  <!--  </div>-->

  <div class="id-info-v2" *ngIf="partnerObject?.assetsRegional?.uuid === 'd095058c-cf4e-4928-be5a-ae55af272d4b'">
    <mat-form-field appearance="fill" color="accent">
      <mat-label>ID</mat-label>
      <input matInput placeholder="ID" [disabled]="true" [value]="partnerObject.recordId?.toString()">
    </mat-form-field>
  </div>

  <div class="id-info" *ngIf="partnerObject?.assetsRegional?.uuid !== 'd095058c-cf4e-4928-be5a-ae55af272d4b'">
    <mat-form-field appearance="fill" color="accent">
      <mat-label>ID</mat-label>
      <input matInput placeholder="ID" [disabled]="true" [value]="partnerObject.recordId?.toString()">
    </mat-form-field>
  </div>

  <div class="competition-requirements-met-status-info"
       *ngIf="partnerObject?.assetsRegional?.uuid !== 'd095058c-cf4e-4928-be5a-ae55af272d4b'">
    <mat-form-field *ngIf="partnerObject.competitionRequirementsMet" appearance="fill"
                    [ngClass]="'input-color-positive'">
      <mat-label>Status IDD konkursy</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="'Aktywny'">
    </mat-form-field>
    <mat-form-field *ngIf="!partnerObject.competitionRequirementsMet" appearance="fill"
                    [ngClass]="'input-color-negative'">
      <mat-label>Status IDD konkursy</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="'Nieaktywny'">
    </mat-form-field>
  </div>

  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + partnerObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="partnerObject.status?.name">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="modify()" [disabled]="!(userPermissions | async).partner.write" mat-stroked-button color="primary">
      <mat-icon>create</mat-icon>
      <span> Edytuj</span></button>
    <!--    <button (click)="delete()" [disabled]="!(userPermissions | async).partner.delete" mat-stroked-button color="warn"><mat-icon>delete</mat-icon> <span> Usuń</span></button>-->

    <button mat-stroked-button [matMenuTriggerFor]="menu" aria-label="Menu" color="primary">
      <mat-icon>settings</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button
        [disabled]="!(userPermissions | async).partner.regional_change"
        (click)="changeRegional()"
        mat-menu-item
      >
        <mat-icon>edit</mat-icon>
        <span> Zmiana regionalnego</span></button>
      <button
        *ngIf="(userPermissions | async).settlement.write"
        (click)="changeCurrentDynamics()"
        mat-menu-item
      >
        <mat-icon>edit</mat-icon>
        <span> Dynamika sprzedaży</span></button>
      <button
        [disabled]="!(userPermissions | async).partner.read || generatingDocument"
        [class.spinner]="generatingDocument" (click)="generatePartnerDataDocuments()"
        mat-menu-item
      >
        <mat-icon>content_copy</mat-icon>
        <span> Wygeneruj potwierdzenie danych</span></button>
      <button
        [disabled]="!(userPermissions | async).partner.regional_change"
        (click)="accountNumber()"
        mat-menu-item
      >
        <mat-icon>edit</mat-icon>
        <span> Zmiana nr rachunku bankowego</span></button>
      <button mat-menu-item [disabled]="true"><span> </span></button>

      <button (click)="delete()" [disabled]="!(userPermissions | async).partner.delete" mat-menu-item color="warn">
        <mat-icon>delete</mat-icon>
        <span> Usuń</span></button>

    </mat-menu>

    <button
      *ngIf="!partnerObject.hasPartnerOCKAccount && (userPermissions | async).ock.create && hasContractOckActive"
      [disabled]="!(userPermissions | async).ock.create  && !partnerObject.hasActiveOCK && ( partnerObject.partnerOCKAccounts?.length > 0 && partnerObject.legalForm.key === LEGAL_FORM_NATURAL_PERSON )"
      (click)="createOCKAccount()"
      mat-stroked-button color="primary"
    >
      <mat-icon>add</mat-icon>
      <span> Dodaj konto OCK</span></button>
  </div>
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">


      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3 *ngIf="partnerObject.ofwcaPartner === false">Dane przedsiębiorstwa</h3>
              <h3 *ngIf="partnerObject.ofwcaPartner === true">Dane osobowe</h3>
            </div>
            <mat-radio-group disabled="true" *ngIf="hidePartner">
              <div fxLayout="row" fxLayoutGap="15px" class="formControlOfwca">
                <div fxFlex="50">
                  <mat-radio-button value="0" [checked]="partnerObject.ofwcaPartner === false">Dane Przedsiębiorstwa
                  </mat-radio-button>
                </div>
                <div fxFlex="50">
                  <mat-radio-button value="1" [checked]="partnerObject.ofwcaPartner === true">Dane OFWCA
                  </mat-radio-button>
                </div>
              </div>
            </mat-radio-group>
            <ng-container *ngIf="partnerObject?.ofwcaPartner === false">
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <app-detail header="Pełna nazwa" [value]="partnerObject.fullName"></app-detail>
                </div>

                <div fxFlex="50">
                  <app-detail header="Skrócona nazwa" [value]="partnerObject.shortName"></app-detail>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <app-detail header="Forma prawna" [value]="partnerObject.legalForm?.name"></app-detail>
                </div>


                <div fxFlex="50">
                  <app-detail header="Typ działalności" [value]="partnerObject.formOfBusiness?.name"></app-detail>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <app-detail header="NIP" [value]="partnerObject.nip"></app-detail>
                </div>

                <div fxFlex="50">
                  <app-detail header="REGON" [value]="partnerObject.regon"></app-detail>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <app-detail header="KRS" [value]="partnerObject.krs"></app-detail>
                </div>

                <div fxFlex="50">
                  <app-detail header="Numer rachunku bankowego" [value]="partnerObject.accountNumber"></app-detail>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">

                <div fxFlex="50">
                  <app-detail-bool header="PKD" [value]="partnerObject.hasPkd"></app-detail-bool>
                </div>


                <div fxFlex="50">
                  <app-detail-bool header="Działalność zagraniczna"
                                   [value]="partnerObject.foreignActivities"></app-detail-bool>
                </div>
              </div>

              <!--            <div fxLayout="row" fxLayoutGap="15px">-->
              <!--              <div fxFlex="100">-->
              <!--                <app-detail-bool header="Samofakturowanie" [value]="partnerObject.selfBilling"></app-detail-bool>-->
              <!--              </div>-->
              <!--            </div>-->

              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <app-detail-bool header="Nowy Partner" [value]="partnerObject.newPartner"></app-detail-bool>
                </div>

                <div fxFlex="50" *ngIf="partnerObject?.assetsRegional?.uuid !== 'd095058c-cf4e-4928-be5a-ae55af272d4b'">
                  <app-detail-bool header="Weryfikacja procesu sprzedaży"
                                   [value]="partnerObject.verificationSalesProcess"></app-detail-bool>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <app-detail-bool header="Niezgodność danych z GUS" [value]="partnerObject.gusMismatchData"></app-detail-bool>
                </div>
              </div>

              <!--            <div fxLayout="row" fxLayoutGap="15px">-->
              <!--              <div fxFlex="100">-->
              <!--                <app-detail-bool header="Rekord zweryfikowany" [value]="partnerObject.verified"></app-detail-bool>-->
              <!--              </div>-->
              <!--            </div>-->
            </ng-container>
            <ng-container *ngIf="partnerObject?.ofwcaPartner === true">
              <ng-container>
                <div fxLayout="row" fxLayoutGap="15px">
                  <div fxFlex="50">
                    <app-detail header="Imię" [value]="partnerObject.ofwcaFirstName"></app-detail>
                  </div>
                  <div fxFlex="50">
                    <app-detail header="Drugie imię" [value]="partnerObject.ofwcaSecondName"></app-detail>
                  </div>
                </div>
              </ng-container>
              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <app-detail header="Nazwisko" [value]="partnerObject.ofwcaLastName"></app-detail>
                </div>

                <div fxFlex="50">
                  <app-detail header="PESEL" [value]="partnerObject.ofwcaPesel"
                              [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <app-detail header="Nazwisko rodowe" [value]="partnerObject.ofwcaFamilyName"
                              [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
                </div>

                <div fxFlex="50">
                  <app-detail header="Nazwisko panieńskie matki" [value]="partnerObject.ofwcaMothersMaidenName"
                              [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <app-detail header="Imię matki" [value]="partnerObject.ofwcaMothersName"
                              [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
                </div>

                <div fxFlex="50">
                  <app-detail header="Imię ojca" [value]="partnerObject.ofwcaFathersName"
                              [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <app-detail header="Miejsce urodzenia" [value]="partnerObject.ofwcaBirthPlace"
                              [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
                </div>

                <div fxFlex="50">
                  <app-detail header="Data urodzenia" [value]="partnerObject.ofwcaBirthDate | date:'y-MM-dd'"
                              [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <app-detail header="Płeć" [value]="partnerObject.ofwcaSex?.name"></app-detail>
                </div>

                <div fxFlex="50">
                  <app-detail header="Wykształcenie" [value]="partnerObject.ofwcaEducation?.name"
                              [limitedAccess]="!(userPermissions | async).ofwca.read"></app-detail>
                </div>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">

                <div fxFlex="100">
                  <app-detail header="Numer rachunku bankowego" [value]="partnerObject.accountNumber"></app-detail>
                </div>
              </div>
            </ng-container>
          </mat-card>
        </div>
      </div>

<!--      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="partnerObject.has360Contract" >-->
<!--        <div fxFlex="100">-->
<!--          <mat-card class="partners-add-card">-->
<!--            <div fxLayout="row">-->
<!--              <h3>Konto ASF360</h3>-->
<!--            </div>-->

<!--            <div fxLayout="row" fxLayoutGap="15px"  *ngIf="partnerObject.user360.length > 0">-->
<!--              <div fxFlex="100">-->
<!--                <ng-container *ngFor="let user of partnerObject.user360; let i = index">-->
<!--                  <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around center">-->
<!--                    <app-detail-bool fxLayoutAlign="space-around center" fxFlex="20" header="Aktywny"-->
<!--                                     [value]="user.active"></app-detail-bool>-->

<!--                    <span fxLayoutAlign="space-around center" fxFlex="20"  class="status">-->
<!--                    {{ user.active ? 'Konto aktywne' : 'Konto nieaktywne' }}-->
<!--                  </span>-->

<!--                    <app-detail fxFlex="65" header="Login">{{ user.username }}</app-detail>-->

<!--                  </div>-->
<!--                </ng-container>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div fxLayout="row" fxLayoutGap="15px"  *ngIf="partnerObject.user360.length === 0">-->
<!--              <div fxFlex="100">-->
<!--                <ng-container>-->
<!--                  <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around center">-->

<!--                    <app-detail fxFlex="50" header="">Brak konta w ASF360</app-detail>-->

<!--                    <div fxFlex="50" style="align-content: center;  text-align: center;" >-->
<!--                      <button-->
<!--                        (click)="sendInvitation(partnerObject.uuid)"-->
<!--                        mat-raised-button color="primary" class="send-password"-->
<!--                      ><span>Wyślij link do rejestracji </span></button>-->
<!--                    </div>-->


<!--                  </div>-->
<!--                  <div fxLayout="row" fxLayoutGap="15px"  *ngIf="(userPermissions | async).partner.delete">-->

<!--                    <app-detail *ngIf="(userPermissions | async).partner.admin_root" fxFlex="50" header="Kod" [value]="partnerObject.settlementPassword "></app-detail>-->

<!--                    <app-detail *ngIf="(userPermissions | async).partner.delete && !(userPermissions | async).partner.admin_root" fxFlex="50" header="Kod" [value]="null " [limitedAccess]="true"></app-detail>-->


<!--                    <div fxFlex="50" style="align-content: center;  text-align: center;" >-->
<!--                      <button-->
<!--                        (click)="sendPassword(partnerObject.uuid)"-->
<!--                        mat-raised-button color="primary" class="send-password"-->
<!--                      > <span>Wyślij kod </span></button>-->
<!--                    </div>-->

<!--                  </div>-->
<!--                </ng-container>-->
<!--              </div>-->



<!--            </div>-->

<!--          </mat-card>-->
<!--        </div>-->
<!--      </div>-->

      <div fxLayout="row" fxFlex.lt-md="100" *ngIf="hasAnyDate()">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane działalności </h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Data rozpoczęcia działalności"
                            [value]="partnerObject.startDate | date:'y-MM-dd'"></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail header="Data zakończenia działalności"
                            [value]="partnerObject.endDate | date:'y-MM-dd'"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Data zawieszenia działalności"
                            [value]="partnerObject.dateOfSuspension | date:'y-MM-dd'"></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail header="Data wznowienia działalności"
                            [value]="partnerObject.resumptionDate | date:'y-MM-dd'"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Data skreślenia działalności z REGON"
                            [value]="partnerObject.deletionRegonData | date:'y-MM-dd'"></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail header="Data orzeczenia upadłości"
                            [value]="partnerObject.judgmentDeclaringDate | date:'y-MM-dd'"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Data zakończenia postępowania upadłościowego"
                            [value]="partnerObject.completionBankruptcyProceedingDate | date:'y-MM-dd'"></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail header="Data skreślenia z rejestru ewidencji"
                            [value]="partnerObject.deletionRegistryData | date:'y-MM-dd'"></app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>


      <div fxLayout="row" fxFlex.lt-md="100" *ngIf='(userPermissions | async).settlement.delete'>
        <div fxFlex="100"  >
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Blokady rozliczeń </h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail-bool header="Blokada wysyłki rozliczenia ASF" [value]="partnerObject.settlementSendBlockAsf"></app-detail-bool>
              </div>
              <div fxFlex="50">
                <app-detail-bool  header="Blokada wysyłki rozliczenia ASF Premium" [value]="partnerObject.settlementSendBlockPremium"></app-detail-bool>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail-bool  header="Blokada generowania faktur ASF" [value]="partnerObject.invoiceGenerateBlockAsf"></app-detail-bool>
              </div>
              <div fxFlex="50">
                <app-detail-bool header="Blokada generowania faktur ASF Premium" [value]="partnerObject.invoiceGenerateBlockPremium"></app-detail-bool>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail-bool header="Blokada komornicza ASF" [value]="partnerObject.invoiceAddBlockAsf"></app-detail-bool>
              </div>
              <div fxFlex="50">
                <app-detail-bool  header="Blokada komornicza ASF Premium" [value]="partnerObject.invoiceAddBlockPremium"></app-detail-bool>
              </div>
            </div>
          </mat-card>
        </div>

      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="partnerObject.representation.length > 0">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Reprezentacja</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <ng-container *ngFor="let representation of partnerObject.representation; let i = index">
                  <div fxLayout="row" fxLayoutGap="15px">
                    <span class="representation-counter" fxFlex="5">{{ i + 1 }}.</span>
                    <app-detail fxFlex="30" header="Imię">{{ representation.firstName }}</app-detail>
                    <app-detail fxFlex="30" header="Nazwisko">{{ representation.lastName }}</app-detail>
                    <app-detail fxFlex="30" header="Funkcja">{{ representation?.functionPartner }}</app-detail>
                  </div>
                </ng-container>
              </div>
            </div>

          </mat-card>
        </div>
      </div>


      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="partnerObject.businessEntities.length > 0">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Podmioty działające w ramach spółki</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <ng-container *ngFor="let businessEntities of partnerObject.businessEntities; let i = index">
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <div class="representation-counterV2">
                        <div fxLayout="row" fxLayoutGap="15px">
                          <span fxFlex="2">{{ i + 1 }}.</span>
                          <app-detail fxFlex="91"
                                      header="Pełna nazwa działalności">{{ businessEntities.businessFullName }}
                          </app-detail>
                        </div>
                        <div fxLayout="row" fxLayoutGap="15px">
                          <span fxFlex="2"></span>
                          <app-detail fxFlex="44" header="Imię">{{ businessEntities.businessFirstName }}</app-detail>
                          <app-detail fxFlex="44" header="Nazwisko">{{ businessEntities.businessLastName }}</app-detail>
                        </div>
                        <div fxLayout="row" fxLayoutGap="15px">
                          <span fxFlex="2"></span>
                          <app-detail fxFlex="44" header="NIP">{{ businessEntities.businessNip }}</app-detail>
                          <app-detail fxFlex="44" header="REGON">{{ businessEntities.businessRegon }}</app-detail>
                        </div>
                      </div>
                    </mat-expansion-panel-header>
                    <div fxLayout="row" fxLayoutGap="15px">
                      <span fxFlex="2"></span>
                      <app-detail fxFlex="44" header="Nr telefonu">{{ businessEntities.businessPhone }}</app-detail>
                      <app-detail fxFlex="44" header="Adres mailowy">{{ businessEntities.businessEmail }}</app-detail>
                    </div>
                    <div fxLayout="row" fxLayoutGap="15px">
                      <span fxFlex="2"></span>
                      <app-detail fxFlex="44" header="Ulica ">{{ businessEntities.businessStreet }}</app-detail>
                      <app-detail fxFlex="21.5" header="Nr budynku">{{ businessEntities.businessHouseNumber }}
                      </app-detail>
                      <app-detail fxFlex="20" header="Nr mieszkania">{{ businessEntities.businessApartmentNumber }}
                      </app-detail>
                    </div>
                    <div fxLayout="row" fxLayoutGap="15px">
                      <span fxFlex="2"></span>
                      <app-detail fxFlex="44" header="Miejscowość">{{ businessEntities.businessCity }}</app-detail>
                      <app-detail fxFlex="44" header="Kod pocztowy">{{ businessEntities.businessZipCode }}</app-detail>
                    </div>
                    <div fxLayout="row" fxLayoutGap="15px">
                      <span fxFlex="2"></span>
                      <app-detail fxFlex="44" header="Województwo">{{ businessEntities.businessState?.name }}
                      </app-detail>
                      <app-detail fxFlex="44" header="Poczta">{{ businessEntities.businessPostCity }}</app-detail>
                    </div>
                    <div fxLayout="row" fxLayoutGap="15px">
                      <span fxFlex="2"></span>
                      <app-detail fxFlex="44" header="Powiat">{{ businessEntities.businessDistrict }}</app-detail>
                      <app-detail fxFlex="44" header="Gmina">{{ businessEntities.businessCommune }}</app-detail>
                    </div>
                  </mat-expansion-panel>
                </ng-container>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Kontakt email</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <h5 class="small-margin-header">
                  Adres email główny </h5>
                <ng-container *ngFor="let email of partnerObject.emails | mainContact; let last = last">
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail fxFlex="50" header="Adres" [value]="email.address"></app-detail>
                    <app-detail fxFlex="50" header="Nazwa" [value]="email.name"></app-detail>
                  </div>
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail-bool fxFlex="33" header="Marketingowe" [value]="email.marketing"></app-detail-bool>
                    <app-detail-bool fxFlex="33" header="Produktowe" [value]="email.product"></app-detail-bool>
                    <app-detail-bool fxFlex="33" header="Rozliczeniowe" [value]="email.billing"></app-detail-bool>
                    <app-detail-bool fxFlex="33" header="Lead'owe" [value]="email.lead"></app-detail-bool>
                  </div>
                </ng-container>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="(partnerObject.emails | additionalContact).length > 0">
              <div fxFlex="100">
                <h5 class="small-margin-header">Adres email dodatkowy</h5>
                <ng-container *ngFor="let email of partnerObject.emails | additionalContact; let last = last">
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail fxFlex="50" header="Adres" [value]="email.address"></app-detail>
                    <app-detail fxFlex="50" header="Nazwa" [value]="email.name"></app-detail>
                  </div>
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail-bool fxFlex="33" header="Marketingowe" [value]="email.marketing"></app-detail-bool>
                    <app-detail-bool fxFlex="33" header="Produktowe" [value]="email.product"></app-detail-bool>
                    <app-detail-bool fxFlex="33" header="Rozliczeniowe" [value]="email.billing"></app-detail-bool>
                    <app-detail-bool fxFlex="33" header="Lead'owe" [value]="email.lead"></app-detail-bool>

                  </div>
                </ng-container>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Kontakt telefoniczny</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <h5 class="small-margin-header">Numer telefonu główny  </h5>
                <ng-container *ngFor="let phone of partnerObject.phones | mainContractPhone; let last = last">
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail fxFlex="50" header="Numer" [value]="phone.number | phone"></app-detail>
                    <app-detail fxFlex="50" header="Nazwa" [value]="phone.name"></app-detail>
                  </div>
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail-bool fxFlex="33" header="Marketingowe" [value]="phone.marketing"></app-detail-bool>
                    <app-detail-bool fxFlex="33" header="Produktowe" [value]="phone.product"></app-detail-bool>
                    <app-detail-bool fxFlex="33" header="Rozliczeniowe" [value]="phone.billing"></app-detail-bool>
                  </div>
                </ng-container>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px"  *ngIf="(partnerObject.phones |  additionalContractPhone).length > 0">
              <div fxFlex="100">
                <h5 class="small-margin-header">Numer telefonu dodatkowy  </h5>
                <ng-container *ngFor="let phone of partnerObject.phones | additionalContractPhone; let last = last">
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail fxFlex="50" header="Numer" [value]="phone.number | phone"></app-detail>
                    <app-detail fxFlex="50" header="Nazwa" [value]="phone.name"></app-detail>
                  </div>
                  <div fxLayout="row" fxLayoutGap="15px">
                    <app-detail-bool fxFlex="33" header="Marketingowe" [value]="phone.marketing"></app-detail-bool>
                    <app-detail-bool fxFlex="33" header="Produktowe" [value]="phone.product"></app-detail-bool>
                    <app-detail-bool fxFlex="33" header="Rozliczeniowe" [value]="phone.billing"></app-detail-bool>
                  </div>
                </ng-container>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="partnerObject.user360.length > 0">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Konto ASF360</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <ng-container *ngFor="let user of partnerObject.user360; let i = index">
                  <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around center">

<!--                    <span fxLayoutAlign="space-around center" fxFlex="35"  class="status">-->
<!--                    {{ user.active ? 'Konto aktywne' : 'Konto nieaktywne' }}-->
<!--                  </span>-->

                    <button
                      fxFlex="35"
                      mat-raised-button
                      [ngClass]="user.active ? 'positive-button' : 'negative-button'"
                    >
                      {{ user.active ? 'Konto aktywne' : 'Konto nieaktywne' }}
                    </button>

                    <app-detail fxFlex="65" header="Login">{{ user.username }}</app-detail>

                  </div>
                </ng-container>
              </div>
            </div>

            <div fxLayout="row">
              <h4 class="structure-title">Treści na tablicy Partnera</h4>
            </div>
            <div fxLayout="row">
              <p class="structure-description">Wybierz rodzaje treści, które będą wyświetlane na tablicy partnera po zalogowaniu do ASF360</p>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail-bool header="Aktualności produktowe"
                                 [value]="partnerObject.productMessageConsent"></app-detail-bool>
              </div>
              <div fxFlex="50">
                <app-detail-bool header="Aktualności marketingowe"
                                 [value]="partnerObject.contestMessageConsent"></app-detail-bool>
              </div>
            </div>

          </mat-card>
        </div>
      </div>

      <div
        fxLayout="row"
        fxFlex.lt-md="100%"
        *ngIf="partnerObject.user360.length === 0"
      >
        <div fxFlex="100">
          <mat-card class="partners-add-card asf360-card">
            <h3>Konto ASF360</h3>

            <div class="account-info">
              <span class="status">Konto nie zostało założone</span>

              <p>
                Partner nie ma jeszcze konta w ASF360. Aby je utworzyć należy
                wypełnić formularz rejestracyjny.
              </p>
            </div>

            <div
              class="registration-row"
              fxLayout="row"
              fxLayout.lt-md="column"
              fxLayoutAlign="start center"
              fxLayoutAlign.lt-md="start stretch"
              fxLayoutGap="24px"
            >
              <div class="registration-details" fxFlex>
                <div class="detail-title">Link do rejestracji</div>
                <div>Wyślij partnerowi link do formularza rejestracyjnego</div>
              </div>

              <div class="registration-action">
                <button
                  mat-raised-button
                  type="button"
                  class="registration-button"
                  (click)="sendInvitation(partnerObject.uuid)"
                >
                  Wyślij link do rejestracji
                </button>
              </div>
            </div>

            <div
              class="registration-row"
              fxLayout="row"
              fxLayout.lt-md="column"
              fxLayoutAlign="start center"
              fxLayoutAlign.lt-md="start stretch"
              fxLayoutGap="24px"
            >
              <div class="registration-details" fxFlex>
                <div class="detail-title">Kod autoryzacyjny do rejestracji</div>
                <div>Partner musi podać ten kod podczas zakładania konta.</div>

                <div class="authorization-code" *ngIf="(userPermissions | async).partner.admin_root" >
                  {{partnerObject.settlementPassword}}
                </div>

              </div>

              <div class="registration-action">
                <button
                  mat-raised-button
                  type="button"
                  class="registration-button"
                  (click)="sendPassword(partnerObject.uuid)"
                >
                  Wyślij kod autoryzacyjny
                </button>
              </div>
            </div>


            <div fxLayout="row">
              <h4 class="structure-title">Treści na tablicy Partnera</h4>
            </div>
            <div fxLayout="row">
              <p class="structure-description">              Wybierz rodzaje treści, które będą wyświetlane na tablicy partnera po zalogowaniu do ASF360
              </p>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail-bool header="Aktualności produktowe"
                                 [value]="partnerObject.productMessageConsent"></app-detail-bool>
              </div>
              <div fxFlex="50">
                <app-detail-bool header="Aktualności marketingowe"
                                 [value]="partnerObject.contestMessageConsent"></app-detail-bool>
              </div>
            </div>
          </mat-card>
        </div>
      </div>


    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <app-detail-address fxFlex.lt-md="100%" header="Adres siedziby"
                          [address]="partnerObject.headquartersAddress"></app-detail-address>
      <app-detail-address fxFlex.lt-md="100%" header="Adres korespondencyjny"
                          [address]="partnerObject.communicationAddress"></app-detail-address>
      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Relacje</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="33">
                <app-detail header="Właściciel (OFWCA)" [value]="partnerObject.owner?.fullName"
                            [link]="partnerObject.owner ? ['/ofwca/szczegoly', partnerObject.owner.uuid] : undefined">
                  <ng-container *ngIf="!partnerObject.owner">Brak</ng-container>
                </app-detail>
              </div>

              <div fxFlex="33">
                <app-detail header="Partner nadrzędny" [value]="partnerObject.parentPartner?.shortName"
                            [link]="partnerObject.parentPartner ? ['/partnerzy/szczegoly', partnerObject.parentPartner.uuid] : undefined"></app-detail>
              </div>

              <div fxFlex="33">
                <app-detail header="Partner nadprowizja" [value]="partnerObject.overcommissionPartner?.shortName"
                            [link]="partnerObject.overcommissionPartner ? ['/partnerzy/szczegoly', partnerObject.overcommissionPartner.uuid] : undefined"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Regionalny (majątek) Partnera">
                  {{ partnerObject.assetsRegional?.fullName }}
                  <ng-container *ngIf="!partnerObject.assetsRegional">Brak</ng-container>
                </app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Regionalny (życie)">
                  {{ partnerObject.lifeRegional?.fullName }}
                  <ng-container *ngIf="!partnerObject.lifeRegional">Brak</ng-container>
                </app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Numer Profitowi" [value]="partnerObject.profitNumber"></app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>
      <ng-container *ngIf="partnerObject?.ofwcaPartner === false">
        <div fxLayout="row" fxFlex.lt-md="100%">
          <div fxFlex="100">
            <mat-card class="partners-add-card">
              <div fxLayout="row">
                <h3>Hiperio</h3>
              </div>

              <div fxLayout="row" fxLayoutGap="15px">
                <div fxFlex="50">
                  <app-detail header="Login" [value]="partnerObject.hiperioLogin"></app-detail>
                </div>

                <div fxFlex="50">
                  <app-detail header="Email" [value]="partnerObject.hiperioEmail"></app-detail>
                </div>
              </div>

            </mat-card>
          </div>
        </div>
      </ng-container>
      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="profitPartner">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Profitowi</h3>
            </div>

            <div fxLayout="column" fxLayoutGap="15px">
              <ng-container *ngFor="let facility of partnerObject.facilities">
                <mat-card>
                  <h4>{{ facility.address.searchString }}</h4>

                  <div fxLayout="row">
                    <app-detail fxFlex="100" header="Dyrektor struktury" [value]="facility.structureDirector?.fullName"
                                [link]="facility.structureDirector ? ['/ofwca/szczegoly', facility.structureDirector.uuid] : undefined"></app-detail>
                  </div>

                  <div fxLayout="row">
                    <app-detail fxFlex="100" header="Wicedyrektor" [value]="facility.assistantDirector?.fullName"
                                [link]="facility.assistantDirector ? ['/ofwca/szczegoly', facility.assistantDirector.uuid] : undefined"></app-detail>
                  </div>

                  <div fxLayout="row">
                    <app-detail fxFlex="100" header="Dyrektor regionalny" [value]="facility.regional?.fullName"
                                [link]="facility.regional ? ['/ofwca/szczegoly', facility.regional.uuid] : undefined"></app-detail>
                  </div>
                </mat-card>
              </ng-container>
            </div>

          </mat-card>
        </div>
      </div>
      <div fxLayout="row" fxFlex.lt-md="100%" *ngIf="partnerObject.partnerOCKAccounts.length > 0">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row" fxLayoutAlign="space-between center">
              <h3 fxFlex="100">Konto ockomisowe.pl</h3>
              <button
                *ngIf="(userPermissions | async).ock.create"
                fxFlex="none"
                [disabled]="!(userPermissions | async).ock.create"

                (click)="addUserOckAccount()"
                mat-stroked-button>
                <mat-icon>add</mat-icon>
                <span> Dodaj konto OCK</span></button>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <ng-container *ngFor="let partnerOckAccount of partnerOCKAccounts; let i = index; let last = last">
                  <div fxLayout="column" fxLayoutGap="15px">
                    <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start start">
                      <div class="representation-counter" fxFlex="none">{{ i + 1 }}.</div>
                      <div fxLayout="column" fxFlex="100" fxLayoutGap="5px">
                        <div fxLayout="row" fxLayoutGap="15px">
                          <app-detail fxFlex="50"
                                      [header]="partnerOckAccount.owner ? 'Login Partnera' : 'Login Użytkownika' ">{{ partnerOckAccount.login }}
                          </app-detail>
                          <app-detail fxFlex="50"
                                      header="Imię i Nazwisko">{{ partnerOckAccount.firstName }} {{ partnerOckAccount.lastName }}
                          </app-detail>
                          <div class="mt-15" fxFlex="none" *ngIf="(userPermissions | async).ock.delete">
                            <button *ngIf="!partnerOckAccount.active"
                                    (click)="editOCKAccount(partnerOckAccount)"
                                    mat-icon-button color="warn" matTooltip="Aktywuj dostęp">
                              <mat-icon *ngIf="!partnerOckAccount.active">check_circle</mat-icon>

                            </button>
                            <button *ngIf="partnerOckAccount.active"
                                    (click)="editOCKAccount(partnerOckAccount)"
                                    mat-icon-button color="warn" matTooltip="Blokuj dostęp">
                              <mat-icon>block</mat-icon>
                            </button>
                          </div>

                        </div>
                        <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-between center">
                          <app-detail fxFlex="100" header="PESEL" [value]="partnerOckAccount.pesel" [limitedAccess]="!(userPermissions | async).ock.create"></app-detail>
                          <mat-chip-list fxFlex="none">
                            <ng-container>
                              <mat-chip class="text-sm" [color]="partnerOckAccount.active  ? 'accent' : 'disable'"
                                        selected>{{ partnerOckAccount.verification ? 'Dane zweryfikowane' : 'Dane niezweryfikowane' }}
                              </mat-chip>
                              <mat-chip class="text-sm" [color]="partnerOckAccount.active ? 'accent' : 'disable'"
                                        selected>{{ partnerOckAccount.active ? 'Konto aktywne' : 'Konto nieaktywne' }}
                              </mat-chip>
                            </ng-container>
                          </mat-chip-list>
                        </div>
                      </div>

                    </div>

                  </div>
                  <div *ngIf="!last" class="mx-15 pt-30 pb-15">
                    <mat-divider class="realative"></mat-divider>
                  </div>
                </ng-container>
              </div>
            </div>

          </mat-card>
        </div>
      </div>




      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Tagi</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="partnerObject.tags.length > 0">
              <div fxFlex="100">
                <app-detail header="">
                  <mat-chip-list>
                    <ng-container *ngFor="let tag of partnerObject.tags; let last = last">
                      <mat-chip color="accent" selected>{{ tag.name }}</mat-chip>
                    </ng-container>
                  </mat-chip-list>
                </app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>


<!--      <div fxLayout="row" fxFlex.lt-md="100%">-->
<!--        <div fxFlex="100">-->
<!--          <mat-card class="partners-add-card">-->
<!--            <div fxLayout="row">-->
<!--              <h3>Zgody</h3>-->
<!--            </div>-->

<!--            <div fxLayout="row" fxLayoutGap="15px">-->
<!--              <div fxFlex="50">-->
<!--                <app-detail-bool header="Wiadomości marketingowe"-->
<!--                                 [value]="partnerObject.contestMessageConsent"></app-detail-bool>-->
<!--              </div>-->
<!--              <div fxFlex="50">-->
<!--                <app-detail-bool header="Wiadomości produktowa"-->
<!--                                 [value]="partnerObject.productMessageConsent"></app-detail-bool>-->
<!--              </div>-->
<!--            </div>-->

<!--          </mat-card>-->
<!--        </div>-->
<!--      </div>-->


      <div fxLayout="row" fxFlex.lt-md="100%">
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Uwagi</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="" [value]="partnerObject.note">
                </app-detail>
              </div>
            </div>

          </mat-card>
        </div>
      </div>


    </div>

  </div>
</div>
